import { render, staticRenderFns } from "./ImageSubComponent.vue?vue&type=template&id=0d2028b3&scoped=true&"
import script from "./ImageSubComponent.vue?vue&type=script&lang=ts&"
export * from "./ImageSubComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ImageSubComponent.vue?vue&type=style&index=0&id=0d2028b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2028b3",
  null
  
)

export default component.exports